export default __webpack_public_path__ + "static/media/reiniciar.232c6d08.png";